
import {VideoRepository} from "@web-libs/features/video/domain/video.repository";
import {HttpClient} from "@web-libs/core/http";
import {parseVideoMeetingDTO, VideoMeetingDTO} from "@web-libs/features/video/api/dto/video.dto";
import {VideoMeeting} from "@web-libs/features/video/domain/video.types";


export const createVideoRepository = (httpClient: HttpClient): VideoRepository => {
  const getMeetingData = async (meetingId: string): Promise<VideoMeeting> => {
    return httpClient.get<VideoMeetingDTO>(`videoMeetings/getToken/${meetingId}`)
        .then((videoMeetingDTO) => {
              return parseVideoMeetingDTO(videoMeetingDTO)
            }
        )
  }
  return {getMeetingData};
}
